import { DateTime } from "luxon";

export type FeatureAnnouncement = {
  id: string;
  title: string;
  description: string;
  fileName: string;
  link: string;
  expiresAt: string;
  routes?: Array<string>;
};

export const useFeatureAnnouncements = () => {
  const { t } = useI18n();
  const route = useRoute();
  const featuresStore = useFeaturesStore();

  const featureAnnouncements: Array<FeatureAnnouncement> = [
    {
      id: "internal-notes",
      title: t("features.internal_notes.title"),
      description: t("features.internal_notes.description"),
      fileName: "internal_notes_2",
      link: null,
      expiresAt: "2026-09-11",
      routes: ["tickets-id"],
    },
  ];

  const isExpired = (feature: FeatureAnnouncement) => {
    const expiresAt = DateTime.fromISO(feature.expiresAt);

    if (!expiresAt.isValid) return true;

    return expiresAt.endOf("day") < DateTime.now();
  };

  const isOnRoute = (feature: FeatureAnnouncement) => {
    if (!feature.routes?.length) return true;

    return feature.routes.includes(route.name as string);
  };

  const currentFeature = computed(() => {
    return (
      featureAnnouncements.find(
        (feature) => !isExpired(feature) && isOnRoute(feature) && !featuresStore.seenFeatures.includes(feature.id)
      ) || null
    );
  });

  const markFeatureAsSeen = (featureId: string) => {
    if (featuresStore.seenFeatures.includes(featureId)) return;

    featuresStore.addSeenFeature(featureId);
  };

  return {
    featureAnnouncements,
    currentFeature,
    markFeatureAsSeen,
  };
};
